import { DebtDisclosure, Script, ScriptType } from "../../lib/api/models";
import { reportError } from "../../lib/bugReporting";

const dd001: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [{ text: "UNREPORTED DEBT DISCLOSURE" }],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long a debt can be reported to a consumer reporting agency. Because of the age of your debt, we cannot report it to a consumer reporting agency. Payment or non-payment of this debt will not affect your credit score.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End.",
      },
    ],
  },
];

const dd002: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      { text: "MASSACHUSETTS STATE SPECIFIC TIME BARRED DISCLOSURE" },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "WE ARE REQUIRED BY REGULATION OF THE MASSACHUSETTS ATTORNEY GENERAL TO NOTIFY YOU OF THE FOLLOWING INFORMATION. THIS INFORMATION IS NOT LEGAL ADVICE: THIS DEBT MAY BE TOO OLD FOR YOU TO BE SUED ON IT IN COURT. IF IT IS TOO OLD, YOU CANNOT BE REQUIRED TO PAY IT THROUGH A LAWSUIT. TAKE NOTE: YOU CAN RENEW THE DEBT AND THE STATUTE OF LIMITATIONS FOR THE FILING OF A LAWSUIT AGAINST YOU IF YOU DO ANY OF THE FOLLOWING: MAKE ANY PAYMENT ON THE DEBT; SIGN A PAPER IN WHICH YOU ADMIT THAT YOU OWE THE DEBT OR IN WHICH YOU MAKE A NEW PROMISE TO PAY; SIGN A PAPER IN WHICH YOU GIVE UP OR WAIVE YOUR RIGHT TO STOP THE CREDITOR FROM SUING YOU IN COURT TO COLLECT THE DEBT. WHILE THIS DEBT MAY NOT BE ENFORCEABLE THROUGH A LAWSUIT, IT MAY STILL AFFECT YOUR ABILITY TO OBTAIN CREDIT OR AFFECT YOUR CREDIT SCORE OR RATING.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End.",
      },
    ],
  },
];

const dd003: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      { text: "NEW MEXICO STATE SPECIFIC TIME BARRED DISCLOSURE" },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      'We are required by New Mexico Attorney General Rule to notify you of the following information. This information is not legal advice: This debt may be too old for you to be sued on in court. If it is too old, you can’t be required to pay it through lawsuit. You can renew the debt and start the time for the filing of a lawsuit against you to collect the debt if you do any of the following: make any payment of the debt; sign a paper in which you admit that you owe the debt or in which you make a new promise to pay; sign a paper in which you give up ("waive") your right to stop the debt collector from suing you in court to collect the debt.',
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End.",
      },
    ],
  },
];

const dd005: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [{ text: "TIME BARRED DISCLOSURE" }],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long you can be sued on a debt. Because of the age of your debt, we will not sue you for it.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

const dd006: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      { text: "MASSACHUSETTS STATE SPECIFIC TIME BARRED DISCLOSURE" },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "WE ARE REQUIRED BY REGULATION OF THE MASSACHUSETTS ATTORNEY GENERAL TO NOTIFY YOU OF THE FOLLOWING INFORMATION. THIS INFORMATION IS NOT LEGAL ADVICE: THIS DEBT MAY BE TOO OLD FOR YOU TO BE SUED ON IT IN COURT. IF IT IS TOO OLD, YOU CANNOT BE REQUIRED TO PAY IT THROUGH A LAWSUIT. TAKE NOTE: YOU CAN RENEW THE DEBT AND THE STATUTE OF LIMITATIONS FOR THE FILING OF A LAWSUIT AGAINST YOU IF YOU DO ANY OF THE FOLLOWING: MAKE ANY PAYMENT ON THE DEBT, SIGN A PAPER IN WHICH YOU ADMIT THAT YOU OWE THE DEBT OR IN WHICH YOU MAKE A NEW PROMISE TO PAY; SIGN A PAPER IN WHICH YOU GIVE UP OR WAIVE YOUR RIGHT TO STOP THE CREDITOR FROM SUING YOU IN COURT TO COLLECT THE DEBT.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [{ text: "UNREPORTED DEBT DISCLOSURE" }],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long a debt can be reported to a consumer reporting agency. Because of the age of your debt, we cannot report it to a consumer reporting agency. Payment or non-payment of this debt will not affect your credit score.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

const dd007: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      { text: "NEW MEXICO STATE SPECIFIC TIME BARRED DISCLOSURE" },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      'We are required by New Mexico Attorney General rule to notify you of the following information. This information is not legal advice: This debt may be too old for you to be sued on it in court. If it is too old, you can’t be required to pay it through a lawsuit. You can renew the debt and start the time for the filing of a lawsuit against you to collect the debt if you do any of the following: make any payment of the debt; sign a paper in which you admit that you owe the debt or in which you make a new promise to pay; sign a paper in which you give up ("waive") your right to stop the debt collector from suing you in court to collect the debt.',
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [{ text: "UNREPORTED DEBT DISCLOSURE" }],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long a debt can be reported to a consumer reporting agency. Because of the age of your debt, we cannot report it to a consumer reporting agency. Payment or non-payment of this debt will not affect your credit score.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

const dd009: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      { text: "COMBINED TIME BARRED AND UNREPORTED DEBT DISCLOSURE" },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long you can be sued on a debt and how long a debt can be reported to a consumer reporting agency. Because of the age of your debt, we will not sue you for it and cannot report it to a consumer reporting agency. Payment or non-payment of this debt will not affect your credit score.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

const dd012: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      { text: "WEST VIRGINIA STATE SPECIFIC TIME BARRED DISCLOSURE" },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long you can be sued on a debt. Because of the age of your debt, we, 1st Financial Bank USA, cannot sue you for it. If you do not pay the debt, we, 1st Financial Bank USA, may report or continue to report it to the credit reporting agencies as unpaid.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

const dd013: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "WEST VIRGINIA STATE SPECIFIC COMBINED TIME BARRED AND UNREPORTABLE DEBT DISCLOSURE",
      },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long you can be sued on a debt. Because of the age of your debt, we, 1st Financial Bank USA, cannot sue you for it and 1st Financial Bank USA cannot report it to any credit reporting agencies.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

const dd017: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "CALIFORNIA STATE SPECIFIC COMBINED TIME BARRED AND UNREPORTED DEBT DISCLOSURE",
      },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long you can be sued on a debt. Because of the age of your debt, we will not sue you for it, and we will not report it to any credit reporting agency.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

const dd019: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      { text: "CALIFORNIA STATE SPECIFIC TIME BARRED DISCLOSURE" },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long you can be sued on a debt. Because of the age of your debt, we will not sue you for it. If you do not pay the debt, we may continue to report it to the credit reporting agencies as unpaid for as long as the law permits this reporting.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

const dd020: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [{ text: "MISSISSIPPI TIME BARRED DEBT DISCLOSURE" }],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long you can be sued on a debt. Because of the age of your debt, we cannot sue you for it. Additionally, under state law, your debt has been extinguished and we cannot collect it from you.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

const dd021: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "MISSISSIPPI COMBINED TIME BARRED AND UNREPORTED DEBT DISCLOSURE",
      },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long you can be sued on a debt. Because of the age of your debt, we cannot sue you for it. Additionally, under state law, your debt has been extinguished and we cannot collect it from you. The law also limits how long a debt can be reported to a consumer reporting agency. Because of the age of your debt, we cannot report it to a consumer reporting agency. Payment or non-payment of this debt will not affect your credit score.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

const dd022: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [{ text: "WISCONSIN TIME BARRED DEBT DISCLOSURE" }],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long you can be sued on a debt. Because of the age of your debt, we cannot sue you for it. Additionally, under state law, your debt has been extinguished and we cannot collect it from you.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

const dd023: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      { text: "WISCONSIN COMBINED TIME BARED AND UNREPORTED DEBT DISCLOSURE" },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long you can be sued on a debt. Because of the age of your debt, we cannot sue you for it. Additionally, under state law, your debt has been extinguished and we cannot collect it from you. The law also limits how long a debt can be reported to a consumer reporting agency. Because of the age of your debt, we cannot report it to a consumer reporting agency. Payment or non-payment of this debt will not affect your credit score.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

const dd024: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [{ text: "NY TIME BARRED DEBT DISCLOSURE" }],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "THE TIME TO SUE ON THIS DEBT HAS EXPIRED.\n\nIF YOU ARE SUED ILLEGALLY:\n•	It is a violation of federal law (the Fair Debt Collection Practices Act),\n•	You may be able to stop the lawsuit by telling the court that the statute of limitations on this debt expired.\n•	You are not required to admit that you owe this debt, promise to pay this debt, or waive the statute of limitations on this debt.\n•	Note: If you make a payment on this debt, the creditors' right to sue you and make you pay the entire debt may start again.\n•	Consult an attorney or a legal aid organization to learn more about your legal rights and options.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

const dd025: Script[] = [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      { text: "NY COMBINED TIME BARED AND UNREPORTED DEBT DISCLOSURE" },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "THE TIME TO SUE ON THIS DEBT HAS EXPIRED.\n\nIF YOU ARE SUED ILLEGALLY:\n•	It is a violation of federal law (the Fair Debt Collection Practices Act),\n•	You may be able to stop the lawsuit by telling the court that the statute of limitations on this debt expired.\n•	You are not required to admit that you owe this debt, promise to pay this debt, or waive the statute of limitations on this debt.\n•	Note: If you make a payment on this debt, the creditors' right to sue you and make you pay the entire debt may start again.\n•	Consult an attorney or a legal aid organization to lean more about your legal rights and options.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [{ text: "UNREPORTED DEBT DISCLOSURE" }],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "The law limits how long a debt can be reported to a consumer reporting agency. Because of the age of your debt, we cannot report it to a consumer reporting agency. Payment or non-payment of this debt will not affect your credit score.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Yes or No, then Click Submit to Record Disclosure.\n\nClick Close button to End",
      },
    ],
  },
];

export default function getDebtDisclosureScriptDetails(
  disclosure: DebtDisclosure,
) {
  if (!disclosure.script) {
    return { name: "", script: [] };
  }

  switch (disclosure.script) {
    case "DD_001":
      return {
        script: dd001,
        name: "DD_001",
      };

    case "DD_002":
      return {
        script: dd002,
        name: "DD_002",
      };

    case "DD_003":
      return {
        script: dd003,
        name: "DD_003",
      };

    case "DD_005":
      return {
        script: dd005,
        name: "DD_005",
      };

    case "DD_006":
      return {
        script: dd006,
        name: "DD_006",
      };

    case "DD_007":
      return {
        script: dd007,
        name: "DD_007",
      };

    case "DD_009":
      return {
        script: dd009,
        name: "DD_009",
      };

    case "DD_012":
      return {
        script: dd012,
        name: "DD_012",
      };

    case "DD_013":
      return {
        script: dd013,
        name: "DD_013",
      };

    case "DD_017":
      return {
        script: dd017,
        name: "DD_017",
      };

    case "DD_019":
      return {
        script: dd019,
        name: "DD_019",
      };

    case "DD_020":
      return {
        script: dd020,
        name: "DD_020",
      };

    case "DD_021":
      return {
        script: dd021,
        name: "DD_021",
      };

    case "DD_022":
      return {
        script: dd022,
        name: "DD_022",
      };

    case "DD_023":
      return {
        script: dd023,
        name: "DD_023",
      };

    case "DD_024":
      return {
        script: dd024,
        name: "DD_024",
      };

    case "DD_025":
      return {
        script: dd025,
        name: "DD_025",
      };

    default:
      reportError(
        new Error(
          "Programmer Error: Could not find script associated with the provided scriptName",
          {
            cause: disclosure.script,
          },
        ),
      );
      return { script: [], name: disclosure.script };
  }
}
